<template>
  <div class="shoppe" v-loading.fullscreen.lock="fullscreenLoading">
    <div class="topcontent">
      <el-cascader
        v-model="queryForm.sellerHouseRuleSectorId"
        :options="sellerHouseRuleSectorList"
        :props="{ expandTrigger: 'hover', emitPath: false }"
        @change="sectorChange"
      ></el-cascader>
    
      <div>
        <el-button type="primary" v-if="customSort" @click="onClickSaveSort">保存排序</el-button>
        <el-button type="primary" @click="onClickAdd">新增规则</el-button>
      </div>
    </div>
    <el-table row-key="sellerHouseRuleId" class="draggable-table" :data="tableData">
      <el-table-column prop="sellerHouseRuleId" label="ID"></el-table-column>
      <el-table-column prop="sellerHouseRuleSectorName" label="所属板块"></el-table-column>
      <el-table-column label="发布日期">
        <template slot-scope="scope">
          {{ scope.row.publishTimeName }}
        </template>
      </el-table-column>
      <el-table-column prop="title" label="标题"></el-table-column>
      <el-table-column prop="updatedBy" label="操作人"></el-table-column>
      <el-table-column label="更新时间">
        <template slot-scope="scope">
          {{ scope.row.updatedAtTime }}
        </template>
      </el-table-column>
      <el-table-column label="编辑">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.disable" @click="showDetail(scope.row)">查看</el-link>
          <el-link type="primary" v-if="!scope.row.disable" @click="editItem(scope.row)">编辑</el-link>
        </template>
      </el-table-column>
      <el-table-column label="是否禁用">
        <template slot-scope="scope">
          <el-link type="primary" v-if="!scope.row.disable" @click="disabledItem(scope.row)">禁用</el-link>
          <el-tag v-if="scope.row.disable" type="danger" size="mini">已禁用</el-tag>
        </template>
      </el-table-column>
      <!-- <el-table-column label="操作">
        <template slot-scope="scope">
          <el-link type="primary" v-if="scope.row.topStatus == 2" @click="topItem(scope.row)">取消置顶</el-link>
          <el-link type="primary" v-if="scope.row.topStatus != 2" @click="unTopItem(scope.row)">置顶</el-link>
        </template>
      </el-table-column> -->
    </el-table>
    <el-pagination class="tr"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="queryForm.pageNo"
      :page-sizes="[10, 25, 50, 100]"
      :page-size="queryForm.pageSize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="total">
    </el-pagination>
  </div>
</template>

<script>
import {
  getNoticeList,
  getRuleList,
  ruleUpate,
  getRuleSectorList,
  disabledNotice,
  topNotice,
  moveRule,
  batchMoveRules,
} from "./api";
import Sortable from "sortablejs";
import utils from '@/utils/util';

export default {
  data() {
    return {
      fullscreenLoading: false,
      sellerHouseRuleSectorList:[],
      sellerHouseRuleSectorMap: {},
      queryForm: {
        pageNo: 1,
        pageSize: 25,
        sellerHouseRuleSectorId: null,
      },
      tableData: [],
      total: 0,
      customSort: false,
    };
  },
  async created(){
    let res = await getRuleSectorList();
    if (res.data && res.data.data) {
      const map = {};
      this.sellerHouseRuleSectorList = res.data.data.map(item => {
        return {
          value: item.sellerHouseRuleSectorId,
          label: item.name,
          children: item.children.map(child => {
            map[child.sellerHouseRuleSectorId] = `${item.name} / ${child.name}`;
            return {
              value: child.sellerHouseRuleSectorId,
              label: child.name,
            };
          }),
        };
      });
      this.queryForm.sellerHouseRuleSectorId = this.sellerHouseRuleSectorList[0].children[0].value;
      this.sellerHouseRuleSectorMap = map;
      this.getTableData();
    }
  },
  mounted() {
    const tbody = document.querySelector(".draggable-table .el-table__body-wrapper tbody");
    new Sortable(tbody, {
      animation: 150,
      // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
      onEnd: ({ newIndex, oldIndex }) => {
        this.customSort = true;
        const targetRow = this.tableData[oldIndex];
        this.tableData.splice(oldIndex, 1);
        this.tableData.splice(newIndex, 0, targetRow);
        // console.error(oldIndex,newIndex,'000')
        // let sellerHouseRuleId = targetRow.sellerHouseRuleId;
        // let beforeSellerHouseRuleId =newIndex==0?null:this.tableData[newIndex-1].sellerHouseRuleId;
        // console.error(beforeSellerHouseRuleId,sellerHouseRuleId,'ss')
        // moveRule({sellerHouseRuleId,beforeSellerHouseRuleId}).then(res=>{
        //   console.error(res,'rrr')
        //   if(res.data&&res.data.success){
        //     setTimeout(() => {
        //       this.getTableData()
        //     });
        //   }
        // })
        // console.table(this.tableData);
      },
    });

  },
  methods: {
    sectorChange() {
      this.queryForm.pageNo = 1;
      this.getTableData()
    },
    search() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    reset() {
      this.queryForm.pageNo = 1;
      this.getTableData();
    },
    getTableData() {
      getRuleList(this.queryForm).then(res => {
        if (res.data && res.data.data) {
          this.total = res.data.data.total;
          this.tableData = (res.data.data.list || []).map(item=>{
            return {
              ...item,
              sellerHouseRuleSectorName: this.sellerHouseRuleSectorMap[item.sellerHouseRuleSectorId] || '',
              publishTimeName:this.dateFormat(item.publishTime),
              updatedAtTime:this.dateFormat(item.updatedAt)

            }
          })
        }
      })
    },
    handleSizeChange(pageSize) {
      this.queryForm.pageSize = pageSize;
      this.getTableData();
    },
    handleCurrentChange(pageNo) {
      this.queryForm.pageNo = pageNo;
      this.getTableData();
    },
    onClickAdd() {

      this.$router.push({ path: '/seller/rules/add' });
    },
    showDetail(row) {
      this.$router.push({ path: '/seller/rules/show/' + row.sellerHouseRuleId });
    },
    editItem(row) {
      this.$router.push({ path: '/seller/rules/edit/' + row.sellerHouseRuleId });
    },
    disabledItem(row) {
      this.$confirm('禁用后用户不可见', '是否禁用', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ruleUpate({
          sellerHouseRuleId: row.sellerHouseRuleId,
          disable: true, // 1：未禁用 2：已禁用
        }).then(res => {
          if (res.data && res.data.success) {
            this.$message.success('发布成功');
            this.getTableData();
          } else {
            this.$message.error(res.data.message || '系统异常');
          }
        });
      }).catch(() => {});
    },
    topItem(row) {
      topNotice({
        sellerNoticeMessageId: row.sellerNoticeMessageId,
        topStatus: 1, // 1.置顶 2.取消置顶
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('置顶成功');
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
    unTopItem(row) {
      topNotice({
        sellerNoticeMessageId: row.sellerNoticeMessageId,
        topStatus: 2, // 1.置顶 2.取消置顶
      }).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('取消置顶成功');
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
      })
    },
    dateFormat(time) {
      if (!time) {
        return '';
      }
      return utils.dateFormat(new Date(time), 'yyyy-MM-dd hh:mm:ss');
    },
    onClickSaveSort() {
      if (this.repeatSubmit) {
        return;
      }
      this.repeatSubmit = true;
      let data = this.tableData.map((item, index) => ({
        sellerHouseRuleId: item.sellerHouseRuleId,
        sortPriority: index + 1,
      }));
      batchMoveRules(data).then(res => {
        if (res.data && res.data.success) {
          this.$message.success('保存排序成功');
          this.customSort = false;
          this.getTableData();
        } else {
          this.$message.error(res.data.message || '系统异常');
        }
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      }).catch(() => {
        setTimeout(() => {
          this.repeatSubmit = false;
        }, 2000);
      });
    },
  },
};
</script>
<style lang="less" scoped>
.shoppe {
  padding: 20px;
}
.topcontent{

  display: flex;
  justify-content: space-between;
  align-items: center;
}
.tr {
  margin-top: 10px;
  text-align: right;
}
.ml10 {
  margin-left: 10px;
}
</style>
